import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1673835616395'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='2688'
    >
        <path
            d='M234.666667 430.933333H128l85.333333-81.066666L345.6 213.333333l51.2 51.2-81.066667 81.066667H896V426.666667H234.666667v4.266666zM793.6 554.666667H896l-85.333333 81.066666-132.266667 132.266667-51.2-51.2 81.066667-81.066667H128V554.666667h665.6z'
            fill='currentColor'
            p-id='2689'
        ></path>
    </svg>
)

export const TogeProjectIcon = props => <Icon component={SVG} {...props} />
